// extracted by mini-css-extract-plugin
export default {"wrapper":"B7rsFARKy_14oPTP2M_Q","title":"C8VuL0xuKuIhl1OO6Pgk","icon":"_ask9_GYGjthp8kR1MgI"};